import React from 'react';
import { format, parseISO } from 'date-fns';
import { usePreApprovalMetrics } from '../context/PreApprovalMetricsContext';
import { Skeleton } from '@/components/ui/skeleton';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from '@/components/ui/table';

export function RecruitmentTable() {
  const { byRecruiter, isLoading } = usePreApprovalMetrics();

  if (isLoading) {
    return (
      <div className="space-y-2">
        {Array.from({ length: 5 }).map((_, i) => (
          <Skeleton key={i} className="h-12 w-full" />
        ))}
      </div>
    );
  }

  if (byRecruiter.length === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        No recruitment activity found in the selected date range
      </div>
    );
  }

  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Recruiter</TableHead>
            <TableHead className="text-center">Recruits</TableHead>
            <TableHead className="text-center">Invites Sent</TableHead>
            <TableHead className="text-center">LO Signed</TableHead>
            <TableHead className="text-center">Counter-Signed</TableHead>
            <TableHead className="text-center">Onboarding Complete</TableHead>
            <TableHead>Last Invite</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {byRecruiter.map((recruiter) => (
            <TableRow key={recruiter.recruiter_id}>
              <TableCell className="font-medium">
                {recruiter.first_name} {recruiter.last_name}
              </TableCell>
              <TableCell className="text-center">
                <span className="font-semibold text-slate-600">{recruiter.recruits_created}</span>
              </TableCell>
              <TableCell className="text-center">
                <span className="font-semibold text-blue-600">{recruiter.invites_sent}</span>
              </TableCell>
              <TableCell className="text-center">
                <span className="font-semibold text-amber-600">{recruiter.lo_signed}</span>
              </TableCell>
              <TableCell className="text-center">
                <span className="font-semibold text-purple-600">{recruiter.counter_signed}</span>
              </TableCell>
              <TableCell className="text-center">
                <span className="font-semibold text-green-600">{recruiter.onboarding_completed}</span>
              </TableCell>
              <TableCell className="text-muted-foreground text-sm">
                {recruiter.last_invite_sent
                  ? format(parseISO(recruiter.last_invite_sent), 'MMM d, yyyy h:mm a')
                  : '—'}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}

export default RecruitmentTable;
